import {
  BrowserRouter as Router
} from "react-router-dom";
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

import MainPage from "./pages/MainPage";
import utils from './utils';
import ScrollToTop from './components/Layout/ScrollToTop';

import './styles/main.scss';
import './index.css';
import SignedOutPage from "./pages/SignedOutPage";

function App() {
  const { isAuthenticated, isLoading } = useAuth0();

  //this enables us to set the urls in AAD application and it will allow any page to auth based on that list
  let locationStr = window.location.pathname;

  let basename = '';

  if( (locationStr.indexOf('/ce/') === 0) ||
      (locationStr.indexOf('/ce') > -1 && locationStr.length < 4)) {
    basename = '/ce';
  }

  let workspaceHint = 'GHMH (public)'; // Default

  if (locationStr.toLowerCase().includes('/ce')) {
  workspaceHint = 'CE (public)';
  }


  useEffect(() => {
    utils.initializeTracking();
  });

  if (isLoading) {
    return null; 
  }

  return (
    <Router basename={basename}>
        <ScrollToTop />
        <div className="App">
          {isAuthenticated ? (
            <MainPage special={basename} workspaceHint={workspaceHint} />
          ) : (
            <SignedOutPage workspaceHint={workspaceHint} />
          )}
        </div>
    </Router>
  );
}

export default App;
